import React, { useState, useRef, useEffect } from "react";
import SidebarMenuItem from "./SidebarMenuItem";

const Sidebar = ({ menuItems }) => {
  const [openMenus, setOpenMenus] = useState({});
  const [hoveredMenu, setHoveredMenu] = useState(null); // Track hovered menu
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // Sidebar toggle state
  const menuRefs = useRef({}); // Refs for tracking menu item positions
  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        if (window.innerWidth < 768) {
          setIsSidebarOpen(false);
        } 
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Automatically close sidebar on smaller screens (mobile)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true); // Ensure sidebar is open on larger screens
      }
    };

    handleResize(); // Initial check on component mount
    window.addEventListener("resize", handleResize); // Add resize event listener

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup on unmount
    };
  }, []);

  const handleToggleMenu = (label) => {
    setOpenMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const calculatePosition = (ref) => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      return {
        top: rect.top + rect.height + window.scrollY - 130,
        left: rect.left + window.scrollX + 60,
      };
    }
    return {};
  };

  // Handle mouse hover logic for opening submenus
  const handleMouseEnter = (label) => {
    setHoveredMenu(label); // Set the hovered menu
  };

  const handleMouseLeave = () => {
    setHoveredMenu(null); // Reset the hovered menu
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev); // Toggle sidebar visibility
  };

  return (
    <>
      {/* Sidebar Toggle Button for Mobile */}
      <button
        onClick={toggleSidebar}
        style={{
          marginLeft: !isSidebarOpen ? "" : "70px",
          background: "transparent",
          outline: "none",
          border: "none",
          fontSize: "16px",
          backgroundColor: "#3A3F51",
          color: "#e1e2e3",
          padding: "8px 16px",
        }}
        className="hidingThisForDesktop"
      >
        <i className="fa-solid fa-caret-right" />
      </button>

      {/* Sidebar Container */}
      <aside className={`aside ${isSidebarOpen ? "" : "hide"}`} ref={sidebarRef}>
        <div className="aside-inner">
          <nav data-sidebar-anyclick-close="" className="sidebar">
            <ul className="nav" style={{ marginTop: "12px" }}>
              {menuItems.map((item) => (
                <SidebarMenuItem
                  key={item.label}
                  item={item}
                  menuRefs={menuRefs}
                  handleToggleMenu={handleToggleMenu}
                  openMenus={openMenus}
                  hoveredMenu={hoveredMenu}
                  handleMouseEnter={handleMouseEnter}
                  handleMouseLeave={handleMouseLeave}
                  calculatePosition={calculatePosition}
                />
              ))}
            </ul>
          </nav>
        </div>

        {/* Render floating submenus for all items with children */}
        {menuItems
          .filter(
            (item) =>
              item.children.length > 0 &&
              (openMenus[item.label] || hoveredMenu === item.label)
          )
          .map((item) => (
            <ul
              key={item.label}
              id={item.label}
              className="nav sidebar-subnav nav-floating"
              onMouseEnter={() => handleMouseEnter(item.label)}
              onMouseLeave={handleMouseLeave}
              style={{
                position: "absolute",
                top: calculatePosition(menuRefs.current[item.label]).top,
                left: calculatePosition(menuRefs.current[item.label]).left,
                width: "200px",
                zIndex: "10",
                fontSize: "12px",
                marginTop: "0px",
                marginLeft: "10px",
              }}
            >
              {item.children.map((child) => (
                <li key={child.label}>
                  <a href={child.link} title={child.label}>
                    <span>{child.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          ))}
      </aside>
    </>
  );
};

export default Sidebar;
